<script>
	import { Router, Link, Route } from "svelte-routing";
	import Login from "./Login.svelte";
	import Room from "./Room.svelte";
	import Main from "./Main.svelte";
	import { store } from "./auth.js";
	import TailwindCss from "./TailwindCss.svelte";

	const rooms = [
		"None",
    "Product",
    "Sales",
    "Cockpit",
    "HR"
	]

	let selectedRoom = ''
	export let url = "";
</script>

<TailwindCss />
<Router url="{url}">

	
  <div>
    <Route path="room/:id" let:params><Room selectedRoom="{params.id}" /> </Route>
    <Route path="home" component="{Main}" />
    <Route path="login" component="{Login}" />
    <Route path="/"><Main /></Route>
  </div>
</Router>
